import {
  DocumentTypeEnum,
  RequiredDocument,
  RequiredDocumentsResponse,
} from '@types'

export function requiredDocumentsTransform(
  response: RequiredDocumentsResponse
): RequiredDocumentsResponse {
  const required_documents: RequiredDocument[] = []

  function composeIndex(index: number, item: RequiredDocument) {
    if (required_documents[index]) {
      required_documents.push(required_documents[index])
      required_documents[index] = item
    } else {
      required_documents[index] = item
    }
  }

  response.required_documents.forEach((item) => {
    switch (item.type) {
      case DocumentTypeEnum.SelfPhoto:
        composeIndex(0, item)
        break
      case DocumentTypeEnum.DocumentFrontPhoto:
        composeIndex(1, item)
        break
      case DocumentTypeEnum.DocumentBackPhoto:
        composeIndex(2, item)
        break
      default:
        required_documents.push(item)
        break
    }
  })
  return {
    ...response,
    required_documents,
  }
}
